import { settings } from '../areas/main/config';

export default function appUrl(url: string): string {
	var appPath = settings.applicationPath;
	if (!appPath) return url;
	return url.replace("~/", appPath);
}
